<template>
  <v-container class="mb-8">
    <Announcement />

    <!-- Home > Animals > ... -->
    <v-breadcrumbs
      class="pl-1 py-2"
      divider=">"
      :items="breadcrumb"
    ></v-breadcrumbs>
    <v-row align="center" justify="space-between" no-gutters>
      <!-- Back Button -->
      <v-btn text small class="px-1" style="height: 40px" @click="back()"
        ><v-icon left small> mdi-chevron-left </v-icon
        >{{ $langs.get('gen.goBack') }}</v-btn
      >
      <!-- <span class="body-2 mr-3 hidden-sm-and-down"
        >Showing 1-20 of 394 results</span
      > -->

      <div class="d-flex align-center justify-end ml-auto" style="flex-basis: 244px">
        <!-- Caterory for SMALL DEVICE -->
        <v-select
          :items="menus"
          :label="$langs.get('product.category')"
          dense
          outlined
          hide-details
          item-value="path"
          item-text="title"
          class="mr-1 hidden-sm-and-up"
          style="flex: 0 1 108px"
        >
          <template slot="item" slot-scope="{ item }">
            <v-list-item :to="`${baseRoute}/${item.path}`" :ripple="false">
              <v-list-item-title>
                {{ $langs.getFunc('product.subType')(item) }}
              </v-list-item-title>
            </v-list-item>
          </template>
        </v-select>

        <!-- Sort By Dropdown -->
        <v-select
          v-model="sort.by"
          @input="sortBy"
          :items="sort.text"
          :disabled="loading"
          :label="$langs.get('productList.sort.by')"
          dense
          outlined
          hide-details
          :prepend-inner-icon="`${sort.iconMode}`"
          :menu-props="{ offsetY: true }"
          style="flex: 0 1 124px"
        >
          <template slot="item" slot-scope="{ item }">
            <v-list-item-title>
              {{ item.describe || item.text }}
            </v-list-item-title>
          </template>
        </v-select>
      </div>
    </v-row>

    <!-- Main List -->
    <v-row
      no-gutters
      class="flex-nowrap"
      :style="{
        'align-items': `${menus.length ? 'flex-start' : 'center'}`,
      }"
    >
      <!-- A side -->
      <v-card
        tile
        flat
        class="hidden-xs-only pa-1 transparent"
        style="flex: 0 0 220px; max-height: 1200px; overflow-x: auto"
      >
        <div v-if="menus.length">
          <div class="text-h6 my-2 primary--text">
            {{ title.subType }} Category
          </div>

          <v-divider width="50%" class="mb-4 bold-1"></v-divider>

          <!-- Each category -->
          <template v-for="({ title, path, subTypes, titleTh }, i) in menus">
            <div :key="path">
              <v-list-item dense :to="`${baseRoute}/${path}`" :ripple="false">
                <v-list-item-content>
                  <v-row no-gutters class="flex-nowrap primary--text">
                    <v-list-item-title>
                      {{
                        $langs.getFunc('product.subType')({ title, titleTh })
                      }}
                    </v-list-item-title>
                    <v-icon small class="" v-if="subTypes"
                      >mdi-format-list-bulleted</v-icon
                    >
                  </v-row>
                </v-list-item-content>
              </v-list-item>
              <v-divider v-if="i + 1 != menus.length"></v-divider>
            </div>
          </template>
        </div>

        <template v-if="false">
          <div class="text-h8 mt-2">Filter by Price</div>
          <!-- Filter Price Slider -->
          <v-range-slider
            hide-details
            v-model="priceFilter.range"
            :min="priceFilter.min"
            :max="priceFilter.max"
            class="no-thumb"
          >
            <template v-slot:prepend>
              <v-text-field
                :value="priceFilter.range[0]"
                class="mt-0 pt-0"
                hide-details
                single-line
                type="number"
                style="width: 45px"
                @change="$set(priceFilter.range, 0, $event)"
              ></v-text-field>
            </template>
            <template v-slot:append>
              <v-text-field
                :value="priceFilter.range[1]"
                class="mt-0 pt-0"
                hide-details
                single-line
                type="number"
                style="width: 45px"
                @change="$set(priceFilter.range, 1, $event)"
              ></v-text-field>
            </template>
          </v-range-slider>
          <!-- Filter Button -->
          <div class="text-center mb-2">
            <v-btn outlined x-small>Filter</v-btn>
            <v-btn outlined x-small color="grey" class="ml-3">Clear</v-btn>
          </div>
        </template>
      </v-card>

      <!-- Item list -->
      <div style="flex-grow: 1">
        <!-- PAGE TITLE -->
        <v-row class="px-4 mt-2" align="center" no-gutters>
          <v-divider class="bold-1"></v-divider>
          <span class="text-h6 px-4 py-2">All {{ title.type }}</span>
          <v-divider class="bold-1"></v-divider>
        </v-row>

        <!-- Item list -->
        <div class="list-item" v-for="product in products" :key="product._id">
          <IntersectionObs :id="product._id" @intersect="markSeen">
            <Item
              class="d-block mx-auto"
              :product="product"
              :type="product.type"
            ></Item>
          </IntersectionObs>
        </div>

        <div v-if="!productCount" class="text-center mt-16">
          {{ $langs.get("product.noDataAvailable")  }}
        </div>

        <!-- Page view -->
        <v-pagination
          class="my-4"
          v-if="!!pageCount"
          v-model="PAGE"
          :length="pageCount"
          :total-visible="visiblePagination[$vuetify.breakpoint.name]"
          :disabled="loading"
          @input="goPage"
        ></v-pagination>
      </div>
    </v-row>
  </v-container>
</template>

<script>
// import ItemList from "@/components/base/ItemList";
import Item from "@/components/base/Item";
import IntersectionObs from "@/components/base/IntersectionObs";
import Announcement from "@/components/base/Announcement";

import api from "@/services/api"; // "@/services/api"
import { getTitle, getMenus, findMenusFirstLevel } from "@/services/constants";

import marketing from "@/services/marketing";

export default {
  name: "ProductList",
  components: {
    // ItemList,
    Item,
    IntersectionObs,
    Announcement,
  },
  data() {
    return {
      ITEM_PRE_PAGE: 48,
      products: [],
      productCount: 0,
      pageCount: 0,
      PAGE: 1,
      visiblePagination: { xs: 4, sm: 6, md: 9, lg: 11 },
      loading: false,
      type: "",
      baseRoute: "",
      title: { subType: "", type: "" },
      menus: [],
      breadcrumb: [],
      sort: {
        by: "0",
        text: [
          {
            text: this.$langs.get("product.price"),
            describe:
              this.$langs.get("productList.sort.priceLowToHigh"),
            value: "1",
          },
          {
            text: this.$langs.get("product.price"),
            describe:
              this.$langs.get("productList.sort.priceHighToLow"),
            value: "2",
          },
          // { text: "Popularity", value: "popular-d" },
          {
            text:  this.$langs.get("productList.sort.recently"),
            value: "0",
          },
        ],
        icon: {
          asc: "mdi-sort-ascending",
          desc: "mdi-sort-descending",
        },
        get iconMode() {
          if (this.by == "0") return "mdi-sort";
          return this.by == "1" ? this.icon.asc : this.icon.desc;
        },
      },
      priceFilter: {
        range: [190, 15000],
        min: 1,
        max: 18000,
      },
    };
  },
  methods: {
    async loadProducts() {
      // =========================================================
      //  parse : menus, t1
      let type = this.$route.path.slice(1).split("/")[0];
      this.type = type;
      let { p1, p2, p3, p4 } = this.$route.params; // p1 = path1
      let route = await this.$store.dispatch("GetRoute");
      if (!route) return;

      // Get sub menus and Show for Main menu:(animals, petfoods, supplies)
      // Deepest Cat. Should not have menus because it's deepest.
      var t1, t2, t3, tTh1;
      this.menus = await getMenus({ type });
      this.baseRoute = `/${type}`;
      this.title.subType = type.capitalize();
      this.title.type = type.capitalize();
      await (async () => {
        let menus;
        if (!p1) return;
        ({
          subTypes: menus,
          title: t1,
          titleTh: tTh1,
        } = findMenusFirstLevel(this.menus, p1));
        this.title.type = t1;
        if (!(menus && menus.length)) return;

        // p1 has subMenus
        this.menus = menus;
        this.baseRoute += `/${p1}`;
        this.title.subType = t1;
        if (!p2) return;
        ({ subTypes: menus, title: t2 } = findMenusFirstLevel(this.menus, p2));
        this.title.type = t2;
        if (!(menus && menus.length)) return;

        // p2 has subMenus
        this.menus = menus;
        this.baseRoute += `/${p2}`;
        this.title.subType = t2;
        if (!p3) return;
        t3 = await getTitle(type, p3, menus);
        this.title.type = t3;
      })();
      this.updatePathOverview({ type, p1, p2, p3, t1, t2, t3, tTh1 });

      this.loading = true;
      // =========================================================
      //  Load product list
      //  e.g.; '/animals/snakes'.slice(1) -> animals/snakes
      let url = this.$route.path.slice(1);
      let params = {
        sort: this.sort.by,
        count: this.productCount == 0,
        page: this.PAGE,
        size: this.ITEM_PRE_PAGE,
      };
      // let _data = api.getCacheProducts(url, params);
      // if (_data) {
      //   this.products = _data.products;
      //   if (_data.products.amount) {
      //     this.productCount = _data.products.amount;
      //     this.pageCount = Math.ceil(amount / this.ITEM_PRE_PAGE);
      //   }
      // }
      let { data } = await api.getProducts(url, params);
      this.loading = false;
      if (!data) return;
      let { products, amount } = data;
      if (!products) return;
      if (amount) {
        this.productCount = amount;
        this.pageCount = Math.ceil(amount / this.ITEM_PRE_PAGE);
      }
      this.products = products;
    },
    updatePathOverview({ type, p1, p2, p3, t1, t2, t3, tTh1 }) {
      this.breadcrumb = [
        { text: this.$langs.get("gen.home"), to: "/" },
      ];
      this.breadcrumb.push({
        text: this.$langs.get(`gen.${type}`),
        to: `/${type}`,
        exact: true,
      });
      if (!t1) return;
      this.breadcrumb.push({
        text: this.$langs.get(`product.subType`)({
          title: t1,
          titleTh: tTh1,
        }),
        to: `/${type}/${p1}`,
        exact: true,
      });
      if (!t2) return;
      this.breadcrumb.push({
        text: t2,
        to: `/${type}/${p1}/${p2}`,
        exact: true,
      });
      if (!t3) return;
      this.breadcrumb.push({
        text: t3,
        to: `/${type}/${p1}/${p2}/${p3}`,
        exact: true,
      });
    },
    goPage(page) {
      if (page == 1) page = undefined;
      this.$router.push({ query: { ...this.$route.query, page } });
      // this.loadProducts();
    },
    sortBy(sort) {
      if (sort == 0) sort = undefined;
      this.PAGE = 1;
      this.$router.push({ query: { sort } });
      // this.loadProducts();
    },
    back() {
      // '/animals/fish'.replace(..) -> '/animals/'
      let path = this.$route.path.replace(/[\w|\-]+\/*$/, "");
      this.$router.push(path);
    },

    // For Product Logs
    markSeen(id, interval) {
      marketing.markSeenProduct({ id, interval });
    },
  },
  mounted() {
    this.PAGE = parseInt(this.$route.query.page) || 1;
    if (this.$route.query.sort) this.sort.by = this.$route.query.sort;
    for (let i = 0; i < 9; i++) this.products.push({});
    this.loadProducts();
  },
  metaInfo() {
    return {
      title: (this.type || "").capitalize(),
      titleTemplate: "%s · ReptTown",
      // meta: [
      //   {
      //     vmid: "description",
      //     name: "description",
      //     content: "ReptTown",
      //   },
      // ],
    };
  },
};
</script>

<style lang="scss" scoped>
.list-item {
  // background: red;
  display: inline-block;

  @media only screen and (min-width: 100px) {
    width: 50%;
  }

  @media only screen and (min-width: 475px) {
    width: 33%;
  }

  @media #{map-get($display-breakpoints, 'sm-and-up' )} {
    // background: green;
    width: 50%;
  }

  // @media only screen and (min-width: map-get($grid-breakpoints, "sm" )) and (max-width: 700px) {
  // }

  @media #{map-get($display-breakpoints, 'md-and-up' )} {
    // background: blue;
    width: 33%;
  }
  @media #{map-get($display-breakpoints, 'lg-and-up' )} {
    // background: chartreuse;
    width: 25%;
  }
}
</style>